import { Scope } from './context/scope/entity';

export const scopesList: Scope[] = [
    Scope.new({
        name: 'Scope of TRA',
    }),
    Scope.new({
        name: 'System description',
    }),
    Scope.new({
        name: 'Intended Operational Environment',
    }),
];
